// extracted by mini-css-extract-plugin
export var authorAvatarContainer = "P_cp";
export var authorInfoContainer = "P_cq";
export var authorInfoDetails = "P_cr";
export var authorInfoSection = "P_cs";
export var authorSocialLinks = "P_cv";
export var authorTooltipContainer = "P_cw";
export var authorTooltipContent = "P_cn";
export var authorTooltipLink = "P_ct";
export var authorTooltipZIndex = "P_cx";